import { z } from "zod"

/* Roles whose call time username comes from Crew Info rather than the user
   record. The backend does not require it for them, so the field is hidden. */
export const ROLES_WITHOUT_CALLNAME = ["extra/second"]

export const isCallnameHiddenRole = (roleName) =>
  ROLES_WITHOUT_CALLNAME.includes(String(roleName || "").trim().toLowerCase())

export const formSchema = z
  .object({
    username: z.string().min(1, "Username is required").max(100),
    email: z.string().email("Invalid email").min(1, "Email is required"),
    lastName: z.string().min(1, "Last name is required"),
    firstName: z.string().min(1, "First name is required"),
    groups: z.number().int().min(1, "Group is required"),
    character: z.union([z.string(), z.number()]).optional().nullable(),
    callTimeUserName: z.string().optional().nullable(),
    // Set by the modals from the selected role so the rule below can read it.
    roleName: z.string().optional().nullable(),
    phoneNumber: z.string().min(1, "Phone number is require"),
  })
  .superRefine((data, ctx) => {
    if (isCallnameHiddenRole(data.roleName)) return

    if (!data.callTimeUserName) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["callTimeUserName"],
        message: "Callname is required",
      })
    }
  })
